import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"

import "./App.vue?vue&type=style&index=0&id=08e602ef&lang=postcss"
import "./App.vue?vue&type=style&index=1&id=08e602ef&lang=postcss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08e602ef"]])

export default __exports__